'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getCallerLocation;
/**
 * @typedef {Object} CallerLocation
 * @property {string} file The location of the callee
 * @property {number} line The line the function was called from
 * @property {number} column The column the function starts at
 */

var LINE_WITH_FUNCTION_NAME = /.*\((.*):(\d+):(\d+)\)/;
var LINE_WITHOUT_FUNCTION_NAME = /(.*):(\d+):(\d+)/;

function getReturnObject(matches) {
  if (!matches) {
    return {
      file: 'Can\'t decipher file',
      line: '',
      column: ''
    };
  }
  return {
    file: matches[1],
    line: matches[2],
    column: matches[3]
  };
}

function matchStack(line) {
  var match = line.match(LINE_WITH_FUNCTION_NAME);
  if (!match) {
    return getReturnObject(line.match(LINE_WITHOUT_FUNCTION_NAME));
  }
  return getReturnObject(match);
}

/**
 * getCallerLocation returns the location from where the function was called
 *
 * @export
 * @param {number} [depth=3] The depth in the stack your caller was.  If get caller location was
 * the only function to be called, the depth will be two.  One is this function, two is where it
 * was called from.
 * @returns {CallerLocation} The CallerLocation of the function
 */
function getCallerLocation() {
  var depth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;

  var e = new Error();
  var stack = e.stack.split('\n').map(function (t) {
    return t.trim();
  });
  var calledFrom = stack[depth];
  return matchStack(calledFrom);
}


//////////////////
// WEBPACK FOOTER
// ./~/jack-logs/util/getCallerLocation.js
// module id = 1173
// module chunks = 0